<adapt-toolbar-title>
    <div class="d-flex align-items-center"
         data-tour="active-meeting-title">
        <h2>{{meeting?.name}}</h2>
    </div>
</adapt-toolbar-title>

<div adaptToolbarContent
     class="d-flex ms-2 gap-2"
     alignment="left">
    <button *ngIf="meeting && meeting.supplementaryData && meeting.supplementaryData.purpose"
            [(adaptCollapsibleButton)]="descriptionCollapsed"
            [adaptTooltip]="descriptionCollapsed ? 'Show description': 'Hide description'"
            [class.pulsing-element]="showDescriptionOnLoad"></button>

    <div class="me-lg-3 align-self-center"
         data-tour="active-meeting-time-elapsed">
        <adapt-meeting-progress-indicator [meeting]="meeting"
                                          [radius]="11"
                                          [singleRow]="true"></adapt-meeting-progress-indicator>
    </div>
</div>

<div *ngIf="meeting"
     adaptToolbarContent
     data-tour="active-meeting-toolbar-actions">
    <button *ngIf="useActiveMeetingPage && isLgBreakpoint"
            adaptButtonIcon="fal fa-chevron-left"
            adaptTooltip="Move meeting display to sidebar"
            data-test="active-meeting-move-to-sidebar-button"
            (click)="moveMeetingToSidebar()">Move to sidebar</button>
    <button *ngIf="canEditTeamMeeting && isLgBreakpoint"
            class="align-self-center btn btn-danger d-flex"
            [ngClass]="{'end-meeting-pulse': meeting.extensions.shouldBeEnded}"
            adaptButtonIcon="fal fa-fw fa-stop-circle"
            [adaptBlockingClick]="endMeeting"
            [adaptBlockingClickParam]="meeting"
            [unsubscribeOnDestroy]="false"
            data-tour="stop-meeting-button"
            data-test="stop-meeting-button">End meeting</button>
    <adapt-meeting-details-menu [meeting]="meeting"
                                [showTour]="true"
                                data-test="active-meeting-actions-menu"
                                [extraMenuOptions]="isLgBreakpoint ? undefined : activeMeetingOptions"
                                menuSize="sm"></adapt-meeting-details-menu>
</div>

<div *ngIf="meeting"
     class="px-1"
     data-test="active-meeting-page"
     data-tour="active-meeting-page">
    <adapt-meeting-shortcut-icons class="d-block mb-2"
                                  [meeting]="meeting"
                                  [showText]="true"></adapt-meeting-shortcut-icons>

    <div *ngIf="meeting.supplementaryData && meeting.supplementaryData.purpose"
         [collapse]="descriptionCollapsed"
         [isAnimated]="true">
        <div class="pb-2">
            <div class="card mb-0"
                 [class.pulsing-element]="showDescriptionOnLoad"
                 [class.shadow-none]="!showDescriptionOnLoad">
                <div class="card-body"
                     [froalaView]="meeting.supplementaryData.purpose"></div>
            </div>
        </div>
    </div>

    <adapt-meeting-sidebar-agenda class="mt-2"
                                  [meeting]="meeting"
                                  (endMeetingCalled)="endMeeting(meeting).subscribe()"
                                  data-tour="meeting-agenda"></adapt-meeting-sidebar-agenda>
</div>
